export default __webpack_public_path__ + "static/media/children sitting.00deea7f.JPG";